import React from "react";
import { RegistryItem } from "../lib/supabase";

interface RegistryItemCardProps {
  item: RegistryItem;
  onMarkAsPurchased?: (itemId: string) => void;
  onDelete?: (itemId: string) => void;
  showAdminActions?: boolean;
  purchasedBy?: string;
}

const RegistryItemCard: React.FC<RegistryItemCardProps> = ({
  item,
  onMarkAsPurchased,
  onDelete,
  showAdminActions = false,
  purchasedBy,
}) => {
  const isExternalLink = item.type === "external_link";

  return (
    <div
      className={`registry-item ${item.purchased ? "purchased" : ""} ${
        isExternalLink ? "external-link" : ""
      }`}
    >
      {item.image_url && (
        <div className="item-image-container">
          <img src={item.image_url} alt={item.name} className="item-image" />
        </div>
      )}
      <div className="item-details">
        <h3>{item.name}</h3>
        {isExternalLink && (
          <span className="external-link-badge">External Registry</span>
        )}
        {/* <p>{item.description}</p> */}
        {!isExternalLink && <p className="price">${item.price}</p>}
        {item.category && <p className="category">{item.category}</p>}

        <div className="item-actions">
          <a
            href={item.registry_url}
            target="_blank"
            rel="noopener noreferrer"
            className="registry-link"
          >
            {isExternalLink ? "View on External Registry" : "View on Store"}
          </a>

          {!item.purchased && !isExternalLink && onMarkAsPurchased && (
            <button
              onClick={() => onMarkAsPurchased(item.id)}
              className="purchase-btn"
            >
              Mark as Purchased
            </button>
          )}

          {item.purchased && !isExternalLink && (
            <div className="purchase-info">
              <span className="purchased-badge">
                Purchased
                {showAdminActions && purchasedBy && ` by ${purchasedBy}`}
                {showAdminActions &&
                  item.purchased_by_id &&
                  item.purchased_by_id !== item.purchased_by_name && (
                    <span className="invite-code">
                      {" "}
                      (Code: {item.purchased_by_id})
                    </span>
                  )}
              </span>
              {showAdminActions && item.purchase_note && (
                <p className="purchase-note">{item.purchase_note}</p>
              )}
            </div>
          )}

          {showAdminActions && onDelete && (
            <button onClick={() => onDelete(item.id)} className="delete-btn">
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistryItemCard;
